/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/
'use strict';

var findIndex = require('core-js/library/fn/array/find-index');

var matcherTypes = require('../matchers/types');
var segmentTransform = require('./segment');
var whitelistTransform = require('./whitelist');
var setTransform = require('./set');
var numericTransform = require('./unaryNumeric');

var _require = require('../convertions'),
    _require$date = _require.date,
    zeroSinceHH = _require$date.zeroSinceHH,
    zeroSinceSS = _require$date.zeroSinceSS;

// Flat the complex matcherGroup structure into something handy.


function transform(matchers) {

  var parsedMatchers = matchers.map(function (matcher) {
    var matcherType = matcher.matcherType,
        negate = matcher.negate,
        keySelector = matcher.keySelector,
        segmentObject = matcher.userDefinedSegmentMatcherData,
        whitelistObject = matcher.whitelistMatcherData,
        unaryNumericObject = matcher.unaryNumericMatcherData,
        betweenObject = matcher.betweenMatcherData;


    var attribute = keySelector && keySelector.attribute;
    var type = matcherTypes.mapper(matcherType);
    var dataType = matcherTypes.dataTypes.STRING; // As default input data type we use string (even for ALL_KEYS)
    var value = undefined;

    if (type === matcherTypes.enum.SEGMENT) {
      value = segmentTransform(segmentObject);
    } else if (type === matcherTypes.enum.WHITELIST) {
      value = whitelistTransform(whitelistObject);
    } else if (type === matcherTypes.enum.EQUAL_TO) {
      value = numericTransform(unaryNumericObject);
      dataType = matcherTypes.dataTypes.NUMBER;

      if (unaryNumericObject.dataType === 'DATETIME') {
        value = zeroSinceHH(value);
        dataType = matcherTypes.dataTypes.DATETIME;
      }
    } else if (type === matcherTypes.enum.GREATER_THAN_OR_EQUAL_TO || type === matcherTypes.enum.LESS_THAN_OR_EQUAL_TO) {
      value = numericTransform(unaryNumericObject);
      dataType = matcherTypes.dataTypes.NUMBER;

      if (unaryNumericObject.dataType === 'DATETIME') {
        value = zeroSinceSS(value);
        dataType = matcherTypes.dataTypes.DATETIME;
      }
    } else if (type === matcherTypes.enum.BETWEEN) {
      value = betweenObject;
      dataType = matcherTypes.dataTypes.NUMBER;

      if (betweenObject.dataType === 'DATETIME') {
        value.start = zeroSinceSS(value.start);
        value.end = zeroSinceSS(value.end);
        dataType = matcherTypes.dataTypes.DATETIME;
      }
    } else if (type === matcherTypes.enum.EQUAL_TO_SET || type === matcherTypes.enum.CONTAINS_ANY_OF_SET || type === matcherTypes.enum.CONTAINS_ALL_OF_SET || type === matcherTypes.enum.PART_OF_SET) {
      value = setTransform(whitelistObject);
      dataType = matcherTypes.dataTypes.SET;
    } else if (type === matcherTypes.enum.STARTS_WITH || type === matcherTypes.enum.ENDS_WITH || type === matcherTypes.enum.CONTAINS_STRING) {
      value = setTransform(whitelistObject);
    }

    return {
      attribute: attribute, // attribute over we should do the matching, undefined means 'use the key'
      negate: negate, // should we negate the result?
      type: type, // which kind of matcher we should evaluate
      value: value, // metadata used for the matching
      dataType: dataType // runtime input data type
    };
  });

  if (findIndex(parsedMatchers, function (m) {
    return m.type === matcherTypes.enum.UNDEFINED;
  }) === -1) {
    return parsedMatchers;
  } else {
    return [];
  }
}

module.exports = transform;


//////////////////
// WEBPACK FOOTER
// ../~/@splitsoftware/splitio/lib/engine/transforms/matchers.js
// module id = 1201
// module chunks = 0